import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import TreeCard from "../../../../../atoms/ActiveLearning/TreeCard";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson8/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson8/Material/Issue2";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson8MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson8Material = (props: Lesson8MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <div className={styles.review}>
          <p className={styles.title}>前回の振り返り</p>
          <TreeCard
            title={"解決のアイデア"}
            text={"回答データがありません。"}
          />
        </div>
        <div className={styles.themEntry}>
          <p className={styles.title}>選んだステップ</p>
          <ul className={styles.pastAnswerList}>
            <li className={styles.pastAnswer}>回答データがありません。</li>
          </ul>
        </div>
        <div className={styles.themEntry}>
          <p className={styles.title}>どんな結果が得られそうか（仮説）</p>
          <ul className={styles.pastAnswerList}>
            <li className={styles.pastAnswer}>回答データがありません。</li>
          </ul>
        </div>
      </div>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson8Material;
